import React, { Component } from "react";

import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

//material ui components
import Grid from '@material-ui/core/Grid';

//material components
import Paper from '@material-ui/core/Paper';
import Moment from 'moment';

//menuItems

class ModalDeleteMenuItem extends Component {
    constructor(props) {
        super();
        this.state = {
            open: false,
            //Resize
            rootFontSize: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 970,
            },
        };
    }

    componentWillMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize.bind(this));
    }

    resize() {
        this.setState({ isMobile: window.innerWidth <= 960 });

        const sizes = {
            xs: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 600,
            },
            sm: {
                name: 'sm',
                fontSize: '60%',
                maxWidht: 1024,
            },
            md: {
                name: 'md',
                fontSize: '80%',
                maxWidht: 1880,
            },
            lg: {
                name: 'lg',
                fontSize: '100%',
                maxWidht: 1920,
            },
        };

        const windowWidht = window.innerWidth;
        const windowHeiht = window.innerHeight;

        let rootFontSize = sizes.xs;

        if (windowWidht > sizes.md.maxWidht) {
            rootFontSize = sizes.lg;
        } else if (windowWidht > sizes.sm.maxWidht) {
            rootFontSize = sizes.md;
        } else if (windowWidht > sizes.xs.maxWidht) {
            rootFontSize = sizes.sm;
        } else {
            rootFontSize = sizes.xs;
        }


        this.setState({
            rootFontSize: rootFontSize,
            windowWidht: windowWidht,
            windowHeiht: windowHeiht,
        });
    }


    //#region  Handlers 
    CleanScheduleModal = () => {

    };
    //#endregion

    //#region  Inner components
    getServeTime(diningItem, timeZoneName) {

        if ((!diningItem || diningItem.dateStart || diningItem.dateEnd) && timeZoneName) {

            const dateStartTimeZone = new Date(new Date(diningItem.dateStart).toLocaleString("en-US", { timeZone: timeZoneName }));
            const dateEndTimeZone = new Date(new Date(diningItem.dateEnd).toLocaleString("en-US", { timeZone: timeZoneName }));

            return `${Moment(dateStartTimeZone).format("MMM D, YYYY")}, ${Moment(dateStartTimeZone).format('LT')} - ${Moment(dateEndTimeZone).format('LT')}`;
        }
        else {
            return ``;
        }
    };

    RenderModalContent = ({ menuItem }) => {


        return (
            <Grid>
                <Paper elevation={3} className="paperModalMenuItem" square='false' color='secondary'>
                    <Grid id='menu_item_deletetion_modal' container justify='flex-start' alignItems='baseline' style={{ height: '100%' }} >
                        <Grid item container alignItems='center' className="TitleRepairsModal">Confirm Menu Item Deletion</Grid>
                        <Grid item container className="RepairsModalContainer">
                            <Grid item container justify='center' alignItems='center' className="subtitleMenuItemModal">
                                <Grid item xs={8}>
                                    Are you sure you want to delete this menu item?
                                </Grid>
                            </Grid>
                            <Grid item container justify='center' alignItems='flex-start' className="ModalmenuItemsContainer">
                                <this.RenderSinglemenuItem menuItem={menuItem} />
                            </Grid>
                            <Grid item container className="ModalButtonsContainer alingCenter" justify='flex-end'>
                                <this.RenderButtonsContainer />
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        );
    };


    RenderSinglemenuItem = ({ menuItem }) => {

        return (
            (menuItem) ?
                <Grid id={`repair_${menuItem._id}`} item container className="padding5">
                    <Grid item direction="row" spacing={0} className="menuItemBackground alingCenter">
                        <Grid item xs={12}>
                            <this.RenderImageComponent menuItem={menuItem} />
                        </Grid>
                        <Grid item xs={12}>
                            <this.MenuItemName menuItem={menuItem} />
                        </Grid>
                        <Grid item xs={12}>
                            <this.ServeTime menuItem={menuItem} />
                        </Grid>
                    </Grid>
                </Grid>
                :
                <Grid></Grid>
        );
    };

    RenderImageComponent = ({ menuItem }) => {

        return (
            <Grid item container className="alingCenter" >
                {
                    (menuItem && menuItem.imageUrl) ?
                        <img
                            className="MenuItemImg"
                            src={menuItem.imageUrl}
                            alt={menuItem.name}
                        />
                        :
                        <Grid item className="altResidentName">{menuItem.name}</Grid>
                }
            </Grid>
        );
    };

    MenuItemName = ({ menuItem }) => {
        return (
            <Grid item container className="alingLeftName padding5">
                {
                    (menuItem && menuItem.name) ?
                        menuItem.name
                        :
                        'N/A'
                }
            </Grid>
        );
    };

    ServeTime = ({ menuItem }) => {
        return (
            <Grid item container className="alingLeftServeTime padding5">
                {
                    this.getServeTime(menuItem, this.props.timeZoneName)
                }
            </Grid>
        );
    };

    RenderButtonsContainer = () => {

        return (
            this.props.recurrence === true ?
                <Grid item container className="alingCenter" direction='row'>
                    <Grid item container className="MenuItemModalButtonNoRecurrence alingCenter">
                        <Grid id='close_repair_return_btn' item container className="alingCenter" onClick={() => this.props.OnCancelHandler()}>
                            No, Exit
                        </Grid>
                    </Grid>
                    <Grid item container className="MenuItemModalButtonYesPurple alingCenter">
                        <Grid id='close_repair_close_btn' item container style={{ width: '70%'}} className="alingCenter" onClick={() => this.props.OnDeleteHandler()}>
                            Yes, Delete This Occurrence
                        </Grid>
                    </Grid>
                    <Grid item container className="MenuItemModalButtonYesRed alingCenter">
                        <Grid id='close_repair_close_btn' item container style={{ width: '70%'}} className="alingCenter" onClick={() => this.props.OnDeleteRecurrenceHandler()}>
                            Yes, Delete All Occurrences
                        </Grid>
                    </Grid>
                </Grid>
                :
                <Grid item container className="alingCenter" direction='row'>
                    <Grid item container className="MenuItemModalButtonNo alingCenter">
                        <Grid id='cancel_repair_return_btn' item container className="alingCenter" onClick={() => this.props.OnCancelHandler()}>
                            No, Exit
                        </Grid>
                    </Grid>
                    <Grid item container className="MenuItemModalButtonYes alingCenter">
                        <Grid id='cancel_repair_cancel_btn' item container className="alingCenter" onClick={() => this.props.OnDeleteHandler()}>
                            Yes, Delete
                        </Grid>
                    </Grid>
                </Grid>
        );
    };
    //#endregion

    render() {
        return (
            <main style={{}}>
                <div>
                    <this.RenderModalContent menuItem={this.props.menuItem ? this.props.menuItem : {}} />
                </div>
            </main>
        )
    }
}

function mapStateToProps(state, dispatch) {

    return {
    }
}


ModalDeleteMenuItem = reduxForm({
    form: 'ModalDeleteMenuItemForm',
    enableReinitialize: true,
})(ModalDeleteMenuItem);

export default connect(mapStateToProps, {})(ModalDeleteMenuItem);

